import { IApplicationState } from "..";
import IAuthenticatedComponentProps from "../../models/IAuthenticatedComponent";

export function selectAuth(state: IApplicationState): IAuthenticatedComponentProps {
  const {
    auth: { ready, isAuthenticated, user },
  } = state;

  if (user) {
    return {
      ready,
      isAuthenticated,
      username: user.username,
      companyId: user.companyId,
      contactId: user.contactId,
      userRoles: user.roles,
      token: user.token,
    };
  } else {
    return {
      ready,
      isAuthenticated,
      username: "",
      companyId: -1,
      contactId: -1,
      userRoles: [],
      token: "",
    };
  }
}
